import Scene from "../scenes/Scene";
import common from "../common";

export default class BaseStage extends Scene {
    constructor(helpStage, activateNextStageButton = false) {
        super();
        this._helpStage = helpStage;
        this.useNextStage = activateNextStageButton;
        this._nextStageButton = null;
        this._muteButton = null;
        this._helpButton = null;
        this._uiActive = false;
        this.signals.help = new P3.utils.MiniSignal();
        this.signals.reload = new P3.utils.MiniSignal();
        this.signals.helpTutorial = new P3.utils.MiniSignal();
        this._bkMusic = null;
        this._tutorialFinger = null;
    }

    init(music = null){
        super.init();
        this._bkMusic = music || P3.audio.playMusic("music_ambient_music_loop_00");
    }

    createUI() {
        this._uiActive = true;
        const assets = P3.assets;

        let states = new P3.ButtonStates();
        states.normal = assets.texture("btn_primary_large_off");
        states.over = assets.texture("btn_primary_large_over");
        states.down = assets.texture("btn_primary_large_down");
        states.icon = assets.texture("icon_play_large_off");

        this._nextStageButton = new P3.Button(states);
        this._nextStageButton.visible = false;
        this.addChild(this._nextStageButton);

        states = new P3.ButtonStates();
        states.normal = assets.texture("btn_primary_small_off");
        states.over = assets.texture("btn_primary_small_over");
        states.down = assets.texture("btn_primary_small_down");
        states.icon = assets.texture("icon_sound_off");
        states.iconAlt = assets.texture("icon_mute_off");

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.visible = false;
        this.addChild(this._muteButton);

        states = new P3.ButtonStates();
        states.normal = assets.texture("btn_primary_small_off");
        states.over = assets.texture("btn_primary_small_over");
        states.down = assets.texture("btn_primary_small_down");
        states.icon = assets.texture("icon_help_off");

        this._helpButton = new P3.Button(states);
        this._helpButton.visible = false;
        this.addChild(this._helpButton);

        this._nextButtonClick = this._nextStageButton.signals.click.add(this.onNextStageButtonClick, this);
        this._helpButton.signals.click.add(this.onHelpButtonClick, this);

        this.animate();
    }

    destroy() {
        this._nextButtonClick.detach();
        // clean up goes here
        super.destroy();
    }

    resize() {
        super.resize();
        if(this._uiActive){
            this._nextStageButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 150;
            this._nextStageButton.y = common.STAGE_HEIGHT * 0.5 + 225;

            this._muteButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 75;
            this._muteButton.y = (common.STAGE_HEIGHT - P3.View.height) * 0.5 + 100;

            this._helpButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 225;
            this._helpButton.y = (common.STAGE_HEIGHT - P3.View.height) * 0.5 + 100;
        }
    }

    animate() {
        let newTween = (button, easing)=>{
            new P3.utils.TWEEN.Tween(button.scale, this.tweens)
                .to({
                    x: .8,
                    y: .8
                }, 340)
                .easing(easing)
                .yoyo(false)
                .delay(1000)
                .onStart(() => {
                    button.visible = true;
                })
                .start();
        };

        this._helpButton.scale.set(0);
        newTween(this._helpButton, P3.utils.Easing.Back2.Out);

        this._muteButton.scale.set(0);
        newTween(this._muteButton, P3.utils.Easing.Back2.Out);

        if (this.useNextStage) {
            this.onStageComplete();
        }
    }

    update() {
        super.update();
    }

    onStageComplete() {
        let self = this;
        this._nextStageButton.scale.set(0);
        new P3.utils.TWEEN.Tween(this._nextStageButton.scale, this.tweens)
            .to({
                x: .8,
                y: .8
            }, 340)
            .easing(P3.utils.Easing.Back3.Out)
            .yoyo(false)
            .delay(1000)
            .onStart(function () {
                self._nextStageButton.visible = true;
            })
            .start();
    }

    onNextStageButtonClick() {
        this.signals.next.dispatch();
        P3.audio.playSound("sfx_btn_accept_00");
    }

    onHelpButtonClick() {
        //common.currentHelpStage = this._helpStage;
        //this.signals.help.dispatch();
        if(this._tutorialFinger){

        }
        this.signals.helpTutorial.dispatch();
        P3.audio.playSound("sfx_btn_accept_00");
    }

    pauseGame() {
        this._helpButton.visible = false;
        this._muteButton.visible = false;
        this._bkMusic.pause();
    }

    resumeGame() {
        this._helpButton.visible = true;
        this._bkMusic.play();
    }
}